import { Button, Form, Input, Spin } from 'antd'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import routes from '@/constants/routes'
import { MachinePart } from '@/types'
import { GetMachinePartResponse } from '@/types/apis/machineParts/GetMachinePartResponse'
import { UpdateMachinePartRequest } from '@/types/apis/machineParts/UpdateMachinePartRequest'

import { SpaceCustom } from '../../style'

export type UpdateMachinePartFormValue = UpdateMachinePartRequest

type Props = {
  washingMachineId: number
  machinePartId: number
  updateLoading: boolean
  getMachinePartResponse: GetMachinePartResponse | undefined
  getLoading: boolean
  machinePartData?: { name: string; code: string }
  onSubmit: (formValues: UpdateMachinePartRequest) => void
  onDelete: (id: MachinePart['id']) => void
}

const UpdateMachinePartForm = ({
  washingMachineId,
  updateLoading,
  getMachinePartResponse,
  getLoading,
  onSubmit,
}: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [form] = Form.useForm<UpdateMachinePartRequest>()

  useEffect(() => {
    if (getMachinePartResponse) {
      form.setFieldsValue(getMachinePartResponse)
    }
  }, [getMachinePartResponse, form])

  const handelSubmit = (values: UpdateMachinePartRequest) => {
    if (getMachinePartResponse) {
      const payload: UpdateMachinePartRequest = {
        ...values,
        washingMachinePartId: getMachinePartResponse?.washingMachinePart.id,
      }

      onSubmit(payload)
    }
  }

  return (
    <Spin spinning={getLoading}>
      <Form layout="vertical" onFinish={handelSubmit} form={form}>
        <Form.Item label={t('components.pages.machineParts.update.form.name')}>
          <Input disabled value={getMachinePartResponse?.washingMachinePart.name} />
        </Form.Item>

        <Form.Item
          label={t('components.pages.machineParts.update.form.totalTimeUsed')}
          name={'totalTimeUsed'}
          rules={[{ required: true, message: t('components.pages.machineParts.update.form.requireTotalTimeUsed') }]}
        >
          <Input addonAfter={t('components.pages.machineParts.update.form.timeUnit')} type="number" min={0} />
        </Form.Item>

        <Form.Item
          label={t('components.pages.machineParts.update.form.totalLife')}
          name={'totalLife'}
          rules={[{ required: true, message: t('components.pages.machineParts.update.form.requireServiceLife') }]}
        >
          <Input addonAfter={t('components.pages.machineParts.update.form.timeUnit')} type="number" min={0} />
        </Form.Item>

        <SpaceCustom>
          <Form.Item>
            <Button
              onClick={() => {
                const path = routes.machineParts.path.replace(':id', washingMachineId.toString())
                navigate(path)
              }}
            >
              {t('components.pages.machineParts.update.form.cancel')}
            </Button>
            <Button type="primary" htmlType="submit" loading={updateLoading}>
              {t('components.pages.machineParts.update.form.update')}
            </Button>
          </Form.Item>
        </SpaceCustom>
      </Form>
    </Spin>
  )
}

UpdateMachinePartForm.displayName = 'UpdateMachinePartForm'
export default UpdateMachinePartForm
